export default "__VITE_ASSET__DkXL7otk__"